<template>
    <div  class="contentWrap activityRules">
        <div class="activityRulesContent">
            <div class="aactivityRulesWrap_contentHide">
                <div class="aactivityRulesCon_item sectMember" ref="sectMember">
                    <div>
             
                        <!-- require('../assets/memberIcon_bright.png'):require('../assets/member_icon.png') -->
                           <img @click="accordion(1)" @mouseover="hoverOver(1,'memberIcon_bright.png')" @mouseout="hoverOver(1,'member_icon.png')" :src="scordUlrl"  alt="">
                            <div>
                                <img src="../assets/patriarchdesire.png" alt="">
                            </div>
                    </div>
                 
                </div>
                <div class="aactivityRulesCon_item patriarch" ref="patriarch">
                    <div>
                        <!-- require('../assets/partriarch_bright.png'):require('../assets/partriarch_icon.png') -->
                           <img @click="accordion(0)" @mouseover="hoverOver(2,'partriarch_bright.png')" @mouseout="hoverOver(2,'partriarch_icon.png')" :src="sectUrl"  alt="">
                            <div>
                                <img src="../assets/patriarchdesire1.png" alt="">
                            </div>
                    </div>
                 
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'activityRules',
     data(){
        return {
            accordionType:0,
            scordUlrl:require('../assets/memberIcon_bright.png'),
            sectUrl:require('../assets/partriarch_icon.png'),
        }
    },
    mounted(){
         if(document.body.offsetWidth<1920){
            document.getElementsByClassName('activityRulesContent')[0].style.transform = 'scale(.9)'
        }
    },
    methods:{
           accordion(type){
            if(type == 1){
                this.$refs.sectMember.style.width = '1106px'
                this.accordionType = 0
                  this.scordUlrl = require('../assets/memberIcon_bright.png')
                this.sectUrl = require('../assets/partriarch_icon.png')
            }else{
                this.$refs.sectMember.style.width = '96px'
                this.accordionType = 1
                  this.scordUlrl = require('../assets/member_icon.png')
                this.sectUrl = require('../assets/partriarch_bright.png')
            }
            
        },
          hoverOver(type,url){
            if(type== 1){
                if(this.accordionType !=0){
                     this.scordUlrl = require('@/assets/'+url)
                }
               
            }else{
                if(this.accordionType !=1){
                         this.sectUrl = require('@/assets/'+url)
                }
           
            }
        },
    }
}
</script>
<style lang="less">
.activityRules{
    .activityRulesContent{
        height:800px;
        width:1200px;
        // background:url(../assets/prizeItem_bg.png);
        background:rgba(0,0,0,.6);
        overflow: hidden;
        position: absolute;
        top:0px;
        right:0px;
        bottom:0px;
        left:0px;
        margin:auto;
        .aactivityRulesWrap_contentHide{
            width:2400px;
        }
        .aactivityRulesCon_item{
                float:left;
                 overflow: hidden;
                 width:1106px;
                 transition: all .8s ease-in-out;
                   >div{
                        width:1106px;
                         >img{
                        float :left;
                    }  
                    >div{
                        width: 996px;
                        background-size:100%;
                        height: 786px;
                        float:left;
                        margin:6px 8px;
                        background:url(../assets/jiao.png);
                        background-size:100%;
                        text-align: center;
                        img{
                            padding-top:58px;
                        }
                    }
         }
               
               
        }
    }
}
</style>